import { render, staticRenderFns } from "./SportelloFabbricatiView.vue?vue&type=template&id=20b47034&"
import script from "./SportelloFabbricatiView.vue?vue&type=script&lang=ts&"
export * from "./SportelloFabbricatiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports